import request from 'services/axios';

export const postPrepaymentSuggest = async (payload: IPrepaymentSuggestProps) => {
  const {data} = await request.post(`/api/v2/market/prepayment-suggestion`, {
    ...payload,
  });
  return data;
};
